import math from '../../mixins/math'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      selectedPaslauga: [],
    }
  },
  mixins: [math],
  computed: {
    ...mapGetters(['paieskaKaina']),
    paslaugaListFull() {
      return [
        {
          text: this.paslaugaPavadinimas('sarasas_hipoteka'),
          tooltip: `Paieška.${
            this.isTurtas ? ' Turtas.' : ''
          } Hipotekų ir įkeitimų, registruotų NTR ir STSR, sąrašas`,
          value: 'sarasasHipoteka',
          hide: this.isKodas,
          required: this.requiredSarasasHipoteka,
          disabled: this.disabledSarasasHipoteka,
          kaina: this.paslaugaKaina('sarasas_hipoteka'),
        },
        {
          text: this.paslaugaPavadinimas('sarasas_sutartis'),
          tooltip:
            'Paieška. Neregistruojamų daiktų sutarčių, registruotų STSR, sąrašas',
          value: 'sarasasSutartis',
          hide: this.isTurtas || this.isTurtasNtr || this.isKodas,
          required: this.requiredSarasasSutartis,
          disabled: this.disabledSarasasSutartis,
          kaina: this.paslaugaKaina('sarasas_sutartis'),
        },
        {
          text: this.paslaugaPavadinimas('patikra_hipoteka'),
          tooltip: `Paieška.${
            this.isTurtas ? ' Turtas.' : ''
          } Hipotekų ir įkeitimų, registruotų NTR ir STSR, patikra`,
          value: 'patikraHipoteka',
          hide: this.isKodas,
          required: this.requiredPatikraHipoteka,
          disabled: this.disabledPatikraHipoteka,
          kaina: this.paslaugaKaina('patikra_hipoteka'),
        },
        {
          text: this.paslaugaPavadinimas('israsas_hipoteka'),
          tooltip: `Paieška. Hipotekų ir įkeitimų, registruotų NTR ir STSR, išrašas`,
          value: 'israsasHipoteka',
          hide: !this.isKodas,
          kaina: this.paslaugaKaina('israsas_hipoteka'),
        },
        {
          text: this.paslaugaPavadinimas('israsas_sutartis'),
          tooltip: `Paieška. Neregistruojamų daiktų sutarčių, registruotų STSR, išrašas`,
          value: 'israsasSutartis',
          hide: !this.isKodas,
          kaina: this.paslaugaKaina('israsas_sutartis'),
        },
        {
          text: this.paslaugaPavadinimas('israsas_ntr'),
          tooltip: `Paieška. Nekilnojamojo turto registro išrašas elektronine forma`,
          value: 'israsasNtr',
          hide:
            !this.isTurtas ||
            !(this.roleNotaras || this.roleRG) ||
            !this.role('ntr3.reg'),
          required: this.requiredIsrasasNtr,
          disabled: this.disabledIsrasasNtr,
          kaina: this.paslaugaKaina('israsas_ntr'),
        },
      ]
    },
    paslaugaList() {
      return this.paslaugaListFull.filter(item => {
        return !item.hide
      })
    },
    requiredSarasasHipoteka() {
      return !(
        this.selectedPaslauga.includes('patikraHipoteka') ||
        this.selectedPaslauga.includes('sarasasSutartis')
      )
    },
    requiredSarasasSutartis() {
      return !(
        this.selectedPaslauga.includes('patikraHipoteka') ||
        this.selectedPaslauga.includes('sarasasHipoteka')
      )
    },
    requiredPatikraHipoteka() {
      return !(
        this.selectedPaslauga.includes('sarasasSutartis') ||
        this.selectedPaslauga.includes('sarasasHipoteka')
      )
    },
    requiredIsrasasNtr() {
      return !(
        this.selectedPaslauga.includes('patikraHipoteka') ||
        this.selectedPaslauga.includes('sarasasHipoteka')
      )
    },
    disabledSarasasHipoteka() {
      return (
        this.selectedPaslauga.includes('patikraHipoteka') ||
        this.selectedPaslauga.includes('israsasNtr')
      )
    },
    disabledSarasasSutartis() {
      return this.selectedPaslauga.includes('patikraHipoteka')
    },
    disabledPatikraHipoteka() {
      return (
        this.selectedPaslauga.includes('sarasasSutartis') ||
        this.selectedPaslauga.includes('sarasasHipoteka') ||
        this.selectedPaslauga.includes('israsasNtr')
      )
    },
    disabledIsrasasNtr() {
      return (
        this.selectedPaslauga.includes('patikraHipoteka') ||
        this.selectedPaslauga.includes('sarasasHipoteka')
      )
    },
    paslaugaListTextAll() {
      let list = []
      if (this.paslaugaData.paslauga === 'sarasas') {
        if (this.paslaugaData.hipoteka) {
          list.push(this.paslaugaPavadinimas('sarasas_hipoteka'))
        }
        if (this.paslaugaData.sutartis) {
          list.push(this.paslaugaPavadinimas('sarasas_sutartis'))
        }
      }
      if (this.paslaugaData.paslauga === 'patikra') {
        list.push(this.paslaugaPavadinimas('patikra_hipoteka'))
      }
      if (this.paslaugaData.paslauga === 'israsas') {
        list.push(this.paslaugaPavadinimas('israsas_ntr'))
      }
      return list.join('<br />')
    },
    paslaugaData() {
      return this.mainData ?? this.parametrai
    },
  },
  methods: {
    paslaugaKaina(paslaugaTipas) {
      if (this.paieskaKaina[paslaugaTipas]) {
        return this.paieskaKaina[paslaugaTipas].kaina
      }
      return 0
    },
    paslaugaPavadinimas(paslaugaTipas) {
      if (this.paieskaKaina[paslaugaTipas]) {
        return this.paieskaKaina[paslaugaTipas].pavadinimas
      }
      return ''
    },
  },
}
